import { DOM, COOKIES } from '@app/utils';

// eslint-disable-next-line require-yield
export function* onSetGDPR(action) {
  const { isGDPR } = action.payload;
  DOM.forceSetCookie(COOKIES.IS_GDPR, isGDPR);
}

export function onSetCountryCode(action) {
  const { countryCode } = action.payload;
  DOM.forceSetCookie('stockx_ip_region', countryCode);
}
